// Values the server renders into <head> (Pages/Shared/_Head.cshtml).

function meta(name: string): string | null {
  return document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content ?? null;
}

/** App root URL ending in "/", e.g. "/" in development or "/HomeLab/" under IIS. */
export function appBase(): string {
  const base = meta('app-base') ?? '/';
  return base.endsWith('/') ? base : `${base}/`;
}

/** Antiforgery request token for state-changing API calls. */
export function csrfToken(): string | null {
  return meta('csrf-token');
}

/** Resolves an app-relative path ("api/account/login") against the app base. */
export function appUrl(path: string): string {
  return appBase() + path.replace(/^\/+/, '');
}
